import trackingService from './tracking';

$(() => {
    trackingService.visitSession({
        timestamp: (new Date()).getTime(),
    });
});
